module.exports = __webpack_public_path__ + "img/Group-1914.c6cfe763.png";